import { Button } from "@mui/material";
import { useNavigate } from "react-router-dom";

const ViewSPOnboarding = () => {
    const navigate = useNavigate();

    return (
        <>
            <div className="main_title">
                <h1>Service Provider Onboarding Details</h1>
                <p>
                    <button onClick={() => navigate("/dashboard")}>Dashboard</button> -{" "}
                    <button onClick={() => navigate("/manage-service-providers")}>
                        Service Provider Onboarding
                    </button>{" "}
                    - View
                </p>
            </div>

            <div className="cards">
                <div className="onboarding_view">
                    {/* Header */}
                    <div className="ov_header">
                        <div>
                            <h2>DesignSphere</h2>
                            <p>contact@designsphere.ae</p>
                        </div>
                        <span className="status in_progress">In Progress</span>
                    </div>

                    {/* Progress */}
                    <div className="ov_progress">
                        <p>Onboarding Progress</p>
                        <div className="progress_steps">
                            <div className="step active">Personal Information</div>
                            <div className="step active">Address Details</div>
                            <div className="step active">Bank Details</div>
                            <div className="step">Additional Documents</div>
                        </div>
                    </div>

                    {/* Meta Cards */}
                    <div className="ov_meta">
                        <div className="meta_card">
                            <p>Current Step</p>
                            <h4>Bank Details</h4>
                        </div>
                        <div className="meta_card">
                            <p>Assigned Reviewer</p>
                            <h4>Operations Team</h4>
                        </div>
                        <div className="meta_card">
                            <p>Started On</p>
                            <h4>14/01/2025</h4>
                        </div>
                        <div className="meta_card">
                            <p>Pending Steps</p>
                            <h4>1</h4>
                        </div>
                    </div>

                    {/* Notes */}
                    <div className="ov_notes">
                        <p>Notes</p>
                        <span>Waiting for bank account verification details</span>
                    </div>

                    {/* Checklist */}
                    <div className="ov_checklist">
                        <p>Checklist</p>

                        <div className="check_item done">Personal information verified</div>
                        <div className="check_item done">Address proof approved</div>
                        <div className="check_item">Validate bank account</div>
                        <div className="check_item">Upload additional documents</div>
                    </div>

                    {/* Footer */}
                    <div className="ov_footer">
                        <Button className="btn" variant="outlined">
                            Close
                        </Button>
                        <Button className="btn btn_primary">
                            Move to Next Step
                        </Button>
                    </div>
                </div>
            </div>
        </>
    );
};

export default ViewSPOnboarding;
